import useLocalDataStore from "@/hooks/common/useLocalDataStore";
import {FilterType} from "@COMPONENTS/product/common/popup/desktop/EventListPopup/EventListPopup";
import {OverlayState} from "@/hooks/common/useOverlay";
import * as style from "@COMPONENTS/style/productlist/optionM";
import {PopupContainer} from "@FRAMEWORK/ui/mobile/popup";
import {Accommodation} from "@QUERIES/prdt/goods/useGoodsOption";
import React from "react";

interface Props {
	goodsCd: string;
	optionList: Accommodation[];
}

const OptionPopup = ({goodsCd, optionList, ...overlayProps}: OverlayState & Props) => {
	const key = "accomSeq";
	const {getLocalData, addLocalData, setLocalData} = useLocalDataStore();
	const filters = (getLocalData("departureFilters") as FilterType[]) ?? [];

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const {checked, value} = e.target;
		const text = e.target.parentNode.lastChild.textContent;

		if (checked) {
			const hasFilter = filters.some(item => item.value === value && item.key === key);

			if (hasFilter) return;
			addLocalData({key: "departureFilters", value: {key, value, text}});
		} else {
			if (key === "accomSeq" && filters.filter(v => v.key === "accomSeq").length === 1) {
				return MessageUtil.alert("옵션은 최소 1개 이상 선택하셔야 합니다.");
			}

			setLocalData({
				key: "departureFilters",
				value: filters.filter(item => !(item.value === value && item.key === key)),
			});
		}
	};

	const initialize = () => {
		const optionsExcluded = filters.filter(e => e.key !== key);
		const allOptions = optionList.map(option => ({key, value: option.accomSeq, text: option.accomNm}));
		setLocalData({key: "departureFilters", value: [...optionsExcluded, ...allOptions]});
	};

	return (
		<PopupContainer
			{...overlayProps}
			title="옵션 선택"
			animate="slideIn"
			size="toast"
			icon={<style.IconButton onClick={initialize} />}
		>
			<style.CheckList>
				{optionList.map((option, index) => (
					<style.CheckListItem key={index}>
						<input
							id={`option${goodsCd}${index}`}
							type="checkbox"
							value={option.accomSeq}
							checked={filters.some(v => v.value.toString() === option.accomSeq.toString()) || false}
							onChange={handleChange}
						/>
						<label htmlFor={`option${goodsCd}${index}`}>
							<span>{option.accomNm}</span>
						</label>
					</style.CheckListItem>
				))}
			</style.CheckList>
		</PopupContainer>
	);
};

export default OptionPopup;
